import React, {useState} from 'react'
import Slider from "react-slick"
import Helmet from "react-helmet"
import Video from '../Video'
import Photo from '../Photo'





const SlideShow = ({slides, slidesToShow}) => {


    // const [slideQty, setSlideQty] = useState(1.2)
    const [pauseVid, setPauseVid] = useState(false)

    console.log('slides to show'+slidesToShow)

    let slideQty

    if(slidesToShow === '2') {
       slideQty = 2.2
    } else {
       slideQty = 1.1
    }
  


    const settings = {
        centerPadding: 0,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: slideQty,
        slidesToScroll: 1,
         beforeChange: () => {
          setPauseVid(true);
        }
    };




       
    return (
        <>
         <Helmet>
                  <link
                    rel="stylesheet"
                    type="text/css"
                    charset="UTF-8"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                    />
                    <link
                    rel="stylesheet"
                    type="text/css"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                    />
                    
            </Helmet>
           
            {console.log(pauseVid)}
          
            <Slider {...settings} className="row-component">

                {
                // loop over slides array
                slides.map((slide, index) => {

                     //get everything after last _ in field name so we can use it for work and inspire
                    const slideFullName = slide.fieldGroupName
                    const slideTypeIndex = slideFullName.lastIndexOf('_')
                    const slideType = slideFullName.substr(slideTypeIndex+1)

                    //check if slide is video and show Video component
                    if(slideType === "SlideshowVideo") {
                        const vidProps = {
                            videoURL: slide.video,
                            altText: slide.posterImage.altText,
                            poster: slide.posterImage.localFile.publicURL,
                            pauseVid
                        }
                        return(
                            <div key={index}>
                                <Video {...vidProps} />
                            </div>
                      ) 
                    }

                    //check if slide is image and show Photo component
                    else if(slideType === "SlideshowImage") {
                        const photoProps = {
                            altText: slide.image.altText,
                            localFile: slide.image.localFile
                        }
                        
                        return (
                            <div className="ss-image" key={index}>
                                <Photo {...photoProps} />
                            </div>
                        )
                    }

                    // if neither slide nor video do nothing
                    else { return null }
                })
            }

            </Slider>
        </>
    )
}

export default SlideShow
